import { release } from '@awayfl/swf-loader';
var namespaceTypeNames = ["Public", "Protected", "PackageInternal", "Private", "Explicit", "StaticProtected"];
export function getNamespaceTypeName(namespaceType) {
    return release ? String(namespaceType) : namespaceTypeNames[namespaceType];
}
